import { defineStore } from 'pinia'

export const useUserAuthStore = defineStore('userAuth', {
  state: () => ({
    username: '',
    role: 0
  }),
  actions: {
    setAuth ({ username, role }: { username: string, role: number }) {
      this.username = username
      this.role = role
    }
  }
})
